export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";